import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCartStore } from '../store/cartStore';
import { useAuthStore } from '../store/authStore';
import { FiTrash2 } from 'react-icons/fi';
import './Cart.css';

function Cart() {
  const { items, fetchCart, removeFromCart, updateCartItem, getCartTotal, getCartItemsCount } = useCartStore();
  const { token } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    fetchCart();
  }, [token, fetchCart]);

  const handleQuantityChange = async (itemId, newQuantity) => {
    if (newQuantity < 1) {
      await removeFromCart(itemId);
    } else {
      await updateCartItem(itemId, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (!token) {
      navigate('/login');
    } else {
      navigate('/checkout');
    }
  };

  return (
    <div className="cart-page">
      <div className="container">
        <h1>Shopping Cart</h1>

        {items.length === 0 ? (
          <div className="empty-cart">
            <h2>Your cart is empty</h2>
            <p>Start shopping to add items to your cart</p>
            <Link to="/products" className="btn btn-primary btn-lg">
              Continue Shopping
            </Link>
          </div>
        ) : (
          <div className="cart-layout">
            {/* Cart Items */}
            <div className="cart-items">
              <table className="cart-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Subtotal</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item) => (
                    <tr key={item.id}>
                      <td className="product-cell">
                        <img
                          src={item.product?.image_url || 'https://via.placeholder.com/80'}
                          alt={item.product?.name}
                          className="product-img"
                        />
                        <div>
                          <p className="product-name">{item.product?.name}</p>
                        </div>
                      </td>
                      <td className="price-cell">
                        Rs {(item.product?.discount_price && item.product?.discount_active !== false ? item.product.discount_price : null) || item.product?.price}
                      </td>
                      <td className="quantity-cell">
                        <div className="quantity-input">
                          <button onClick={() => handleQuantityChange(item.id, item.quantity - 1)}>
                            −
                          </button>
                          <input type="number" value={item.quantity} readOnly />
                          <button onClick={() => handleQuantityChange(item.id, item.quantity + 1)}>
                            +
                          </button>
                        </div>
                      </td>
                      <td className="subtotal-cell">
                        Rs {(((item.product?.discount_price && item.product?.discount_active !== false ? item.product.discount_price : null) || item.product?.price) * item.quantity).toFixed(0)}
                      </td>
                      <td className="action-cell">
                        <button
                          onClick={() => removeFromCart(item.id)}
                          className="remove-btn"
                          title="Remove item"
                        >
                          <FiTrash2 />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Cart Summary */}
            <aside className="cart-summary">
              <div className="summary-card">
                <h3>Order Summary</h3>

                <div className="summary-row">
                  <span>Subtotal:</span>
                  <span>Rs {getCartTotal().toFixed(0)}</span>
                </div>

                <div className="summary-row">
                  <span>Shipping:</span>
                  <span>Rs 200</span>
                </div>

                <div className="summary-divider"></div>

                <div className="summary-row total">
                  <span>Total:</span>
                  <span>Rs {(getCartTotal() + 200).toFixed(0)}</span>
                </div>

                <button className="btn btn-primary btn-lg" onClick={handleCheckout}>
                  Proceed to Checkout
                </button>

                <Link to="/products" className="btn btn-outline btn-lg">
                  Continue Shopping
                </Link>
              </div>

              <div className="promo-section">
                <input type="text" placeholder="Promo code" />
                <button className="btn btn-sm">Apply</button>
              </div>
            </aside>
          </div>
        )}
      </div>
    </div>
  );
}

export default Cart;
